import React from "react";
import styled from "styled-components";

// components
import SearchBar from "./SearchBar";

//styles
import { convertPxToRem } from "frontend/components/helpers";
const IconPhotoSearchBarStyled = styled.div`
    margin-bottom: ${convertPxToRem(32)};
`;

// component
export const IconPhotoSearchBar = () => {
    return (
        <IconPhotoSearchBarStyled>
            <SearchBar />
        </IconPhotoSearchBarStyled>
    );
};

export default IconPhotoSearchBar;
